import React from "react";
import Navbar from "./Navbar/Navbar";
import logo from "../../assets/images/LogoGreenWithX.png";
import "./Header.css";
function Header() {
  return (
    <div
      data-animation="default"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="navbar aiiroxnavbar w-nav"
    >
      <div className="container w-container">
        <div className="w-layout-hflex nav_content_wrapper">
          <div className="logoAndtxt">
            <a href="./index.html" className="w-nav-brand logoXText">
              <img src={logo} alt="" className="logo headerLogo" />
            </a>
          </div>

          <Navbar />
        </div>
      </div>
    </div>
  );
}

export default Header;
